import { render, staticRenderFns } from "./baseDataProductType.vue?vue&type=template&id=9321da3e&scoped=true&"
import script from "./baseDataProductType.vue?vue&type=script&lang=js&"
export * from "./baseDataProductType.vue?vue&type=script&lang=js&"
import style0 from "./baseDataProductType.vue?vue&type=style&index=0&id=9321da3e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9321da3e",
  null
  
)

export default component.exports